import { useEffect, useState } from 'react';
import axios from 'axios';

// Admin panel: payments that were received but never got a token. Retry, optionally correcting the meter number.
export default function UnfulfilledPanel({ headers }) {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(null);
  const [meters, setMeters] = useState({});
  const [msg, setMsg] = useState(null);

  const load = () =>
    axios.get('/api/payment/unfulfilled', { headers })
      .then((r) => setRows(r.data.transactions))
      .catch(() => setRows([]));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);

  const retry = async (t) => {
    setBusy(t.id);
    setMsg(null);
    try {
      const meterNumber = (meters[t.id] ?? t.account_number).trim();
      const r = await axios.post(`/api/payment/transactions/${t.id}/retry`, { meterNumber }, { headers });
      setMsg({ ok: true, text: `Token issued for ${meterNumber}: ${r.data.token}. The customer has been notified.` });
      load();
    } catch (err) {
      setMsg({ ok: false, text: err.response?.data?.message || 'Retry failed' });
      load();
    } finally {
      setBusy(null);
    }
  };

  if (!rows || rows.length === 0) return null;

  const cell = { padding: '10px 12px', color: '#e2e8f0', fontSize: 14.5, whiteSpace: 'nowrap' };
  return (
    <div style={{ background: 'rgba(15,23,42,0.92)', borderRadius: 16, border: '1px solid rgba(251,191,36,0.35)', padding: 0, overflow: 'hidden' }}>
      <div style={{ padding: '16px 20px', borderBottom: '1px solid rgba(251,191,36,0.2)' }}>
        <h3 style={{ color: '#fbbf24', fontSize: 15, fontWeight: 700, margin: 0 }}>{rows.length} paid {rows.length === 1 ? 'payment' : 'payments'} without a token</h3>
        <div style={{ color: '#cbd5e1', fontSize: 13.5, marginTop: 4 }}>Customers paid but no token was issued. Fix the meter number if it was mistyped, then retry.</div>
      </div>
      {msg && <div style={{ padding: '10px 20px', color: msg.ok ? '#10b981' : '#f87171', fontSize: 14.5 }}>{msg.text}</div>}
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>{['Date', 'Tenant', 'Phone', 'M-Pesa ref', 'Amount', 'Meter', 'Problem', ''].map((h) => (
              <th key={h} style={{ ...cell, color: '#cbd5e1', fontSize: 12.5, textTransform: 'uppercase', letterSpacing: 1, textAlign: 'left' }}>{h}</th>
            ))}</tr>
          </thead>
          <tbody>
            {rows.map((t) => (
              <tr key={t.id} style={{ borderTop: '1px solid rgba(255,255,255,0.04)' }}>
                <td style={cell}>{new Date(t.created_at).toLocaleString('en-KE', { dateStyle: 'short', timeStyle: 'short' })}</td>
                <td style={cell}>{t.tenant || 'Main site'}</td>
                <td style={cell}>{t.phone_number}</td>
                <td style={{ ...cell, fontFamily: 'monospace' }}>{t.mpesa_ref || '—'}</td>
                <td style={cell}>KES {Number(t.amount).toLocaleString()}</td>
                <td style={cell}>
                  <input value={meters[t.id] ?? t.account_number} onChange={(e) => setMeters((m) => ({ ...m, [t.id]: e.target.value }))}
                    style={{ width: 120, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(56,189,248,0.25)', borderRadius: 6, padding: '5px 8px', color: '#e2e8f0', fontFamily: 'monospace', fontSize: 13.5 }} />
                </td>
                <td style={{ ...cell, whiteSpace: 'normal', maxWidth: 260, color: '#f87171' }}>{t.fulfillment_error || 'Token still being generated'}</td>
                <td style={cell}>
                  <button onClick={() => retry(t)} disabled={busy === t.id}
                    style={{ background: 'rgba(251,191,36,0.12)', border: '1px solid rgba(251,191,36,0.4)', borderRadius: 8, padding: '6px 12px', color: '#fbbf24', fontSize: 13.5, fontWeight: 600, cursor: 'pointer' }}>
                    {busy === t.id ? 'Retrying…' : 'Retry'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
